/**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2018 Photon Storm Ltd.
 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
 */

/**
 * @namespace Phaser.Math.Angle
 */

module.exports = {

    Between: require('./Between'),
    BetweenY: require('./BetweenY'),
    BetweenPoints: require('./BetweenPoints'),
    BetweenPointsY: require('./BetweenPointsY'),
    Reverse: require('./Reverse'),
    RotateTo: require('./RotateTo'),
    ShortestBetween: require('./ShortestBetween'),
    Normalize: require('./Normalize'),
    Wrap: require('./Wrap'),
    WrapDegrees: require('./WrapDegrees')

};



//////////////////
// WEBPACK FOOTER
// ./math/angle/index.js
// module id = 812
// module chunks = 0